//////////////////
// IMPORTS
//////////////////

// libraries
import React from "react";
import { useQuery } from "@apollo/client";

import { WebSettingsIntegrationsQueryDocument } from "./__generated__/WebSettingsIntegrations.generated";

// components
import { WebSettingsContainer } from "../web-settings-container";
import { AsanaIntegration } from "./AsanaIntegration";
import { SlackIntegration } from "./SlackIntegration";
import { ZoomIntegration } from "./ZoomIntegration";

// constants
// import { paths } from "@clockwise/client-commons/src/constants/site";

// util
// import { OnboardingStep } from "@clockwise/web-commons/src/util/onboarding.util";
// import { FlagNamespaces, UserFlags } from "@util/flags.util";
// import { ZonedMoment } from "@util/time-zone.util";
import { getCurrentOrg } from "@util/org.util";
// import { windowLocation } from "@util/location.util";
import { page, PageEvents } from "@util/analytics.util";
import { logger } from "@util/logger.util";

// material-ui
import { Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Web Settings Integrations
// ~-~-~-~-~-~-~-
interface IProps {}

const useStyles = makeStyles({
  h1: {
    marginBottom: 44,
  },
  divider: {
    margin: "75px 0 40px 0",
  },
});

export const WebSettingsIntegrations = (_props: IProps) => {
  const classes = useStyles();

  React.useEffect(() => {
    page(PageEvents.WEB_SETTINGS_INTEGRATIONS);
  }, []);

  const { loading, data, error, refetch } = useQuery(WebSettingsIntegrationsQueryDocument);

  if (error) {
    logger.error(`failed to load WebSettingsIntegrations: ${error}`);
    return (
      <WebSettingsContainer>
        An error occurred while loading Clockwise:
        <br />
        {error.message}
      </WebSettingsContainer>
    );
  }

  if (!data || loading) {
    return <WebSettingsContainer>Loading…</WebSettingsContainer>;
  }

  const viewer = data.viewer;
  const org = getCurrentOrg(viewer);

  if (!org) {
    return <WebSettingsContainer>Loading…</WebSettingsContainer>;
  }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  return (
    <WebSettingsContainer>
      <Typography variant="h1" className={classes.h1}>
        Integrations
      </Typography>
      <SlackIntegration org={org} refetch={refetch} />
      <Divider className={classes.divider} />
      <ZoomIntegration org={org} refetch={refetch} />
      <Divider className={classes.divider} />
      <AsanaIntegration org={org} refetch={refetch} />
    </WebSettingsContainer>
  );
};
